import { useLocation } from "react-router-dom";

export type Tab =
  | "contractors"
  | "clients"
  | "feedback"
  | "gas-stations"
  | "help";

export const useActiveTab = (): Tab | undefined => {
  const location = useLocation();

  if (location.pathname.includes("/gas-stations")) return "gas-stations";
  if (location.pathname.includes("/feedback")) return "feedback";
  if (location.pathname.includes("/clients")) return "clients";
  if (location.pathname.includes("/contractors")) return "contractors";
  if (location.pathname.includes("/help")) return "help";

  return undefined;
};
